"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("react");
const nano_css_1 = require("nano-css");
const cache_1 = require("nano-css/addon/cache");
const stable_1 = require("nano-css/addon/stable");
const nesting_1 = require("nano-css/addon/nesting");
const atoms_1 = require("nano-css/addon/atoms");
const rule_1 = require("nano-css/addon/rule");
const drule_1 = require("nano-css/addon/drule");
const sheet_1 = require("nano-css/addon/sheet");
const dsheet_1 = require("nano-css/addon/dsheet");
const useStyles_1 = require("nano-css/addon/useStyles");
const jsx_1 = require("nano-css/addon/jsx");
const decorator_1 = require("nano-css/addon/decorator");
const keyframes_1 = require("nano-css/addon/keyframes");
const fadeIn_1 = require("nano-css/addon/animate/fadeIn");
const fadeInDown_1 = require("nano-css/addon/animate/fadeInDown");
const fadeInScale_1 = require("nano-css/addon/animate/fadeInScale");
const Normalize_1 = require("nano-css/addon/reset/Normalize");
const reset_font_1 = require("nano-css/addon/reset-font");
const googleFont_1 = require("nano-css/addon/googleFont");
tslib_1.__exportStar(require("nano-css"), exports);
const nano = nano_css_1.create({
    pfx: 'p4-',
    h: react_1.createElement,
});
exports.nano = nano;
cache_1.addon(nano);
stable_1.addon(nano);
nesting_1.addon(nano);
atoms_1.addon(nano);
rule_1.addon(nano);
drule_1.addon(nano);
sheet_1.addon(nano);
dsheet_1.addon(nano);
useStyles_1.addon(nano);
jsx_1.addon(nano);
decorator_1.addon(nano);
keyframes_1.addon(nano);
fadeIn_1.addon(nano);
fadeInDown_1.addon(nano);
fadeInScale_1.addon(nano);
googleFont_1.addon(nano);
exports.globalCss = () => {
    Normalize_1.addon(nano);
    reset_font_1.addon(nano);
};
exports.put = nano.put;
exports.rule = nano.rule;
exports.drule = nano.drule;
exports.sheet = nano.sheet;
exports.keyframes = nano.keyframes;
exports.css = nano.css;
const { dsheet, useStyles, jsx, googleFont } = nano;
exports.dsheet = dsheet;
exports.useStyles = useStyles;
exports.jsx = jsx;
exports.googleFont = googleFont;
//# sourceMappingURL=index.js.map